import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const paymentService = {
  /**
   * Create a checkout session
   * @param {string} packageId - The package ID from backend
   * @param {string} userEmail - Optional user email
   * @param {object} metadata - Optional metadata
   * @returns {Promise<{checkout_url: string, session_id: string}>}
   */
  async createCheckoutSession(packageId, userEmail = null, metadata = {}) {
    try {
      const origin = window.location.origin;
      const response = await axios.post(`${API}/payments/checkout/session`, {
        package_id: packageId,
        origin_url: origin,
        user_email: userEmail,
        metadata
      });
      return response.data;
    } catch (error) {
      console.error('Error creating checkout session:', error);
      throw error;
    }
  },

  /**
   * Get checkout session status
   * @param {string} sessionId - The Stripe session ID
   * @returns {Promise<{payment_status: string, status: string, amount: number}>}
   */
  async getCheckoutStatus(sessionId) {
    try {
      const response = await axios.get(`${API}/payments/checkout/status/${sessionId}`);
      return response.data;
    } catch (error) {
      console.error('Error getting checkout status:', error);
      throw error;
    }
  },

  /**
   * Get all payment packages
   * @returns {Promise<{products: object, subscriptions: object}>}
   */
  async getPackages() {
    try {
      const response = await axios.get(`${API}/payments/packages`);
      return response.data;
    } catch (error) {
      console.error('Error getting packages:', error);
      throw error;
    }
  },

  /**
   * Map product SKU to package ID
   * @param {string} sku - Product SKU
   * @returns {string} Package ID
   */
  mapSkuToPackageId(sku) {
    // Map frontend SKUs to backend package IDs
    const skuMap = {
      // Juices
      'berry-blast-16oz': 'juice_single',
      'citrus-sunrise-16oz': 'juice_single',
      'green-power-16oz': 'juice_single',
      'midnight-orchard-16oz': 'juice_single',
      'tropical-tangy-16oz': 'juice_single',
      'pine-hills-phoenix-16oz': 'juice_single',
      
      // Tea
      'tea-pouch-variety-pack': 'tea_pouch',
      
      // Mixed Drinks
      'mocktail-mixer-lite-16oz': 'mixer_single',
      'classic-mixer-16oz': 'mixer_single',
      'party-pack-4-mixers': 'mixer_4pack',
      
      // Apparel
      'teeaze-classic-tee-white': 'tee_shirt',
      'teeaze-classic-tee-pink': 'tee_shirt',
      'teeaze-mixer-design-green': 'tee_shirt',
      'teeaze-mixer-variety-pack': 'tee_shirt',
      'teeaze-hoodie-black': 'hoodie',
    };
    
    return skuMap[sku] || 'juice_single'; // Default fallback
  },

  /**
   * Map subscription tier to package ID
   * @param {string} tierId - Subscription tier ID
   * @returns {string} Package ID
   */
  mapSubscriptionToPackageId(tierId) {
    const tierMap = {
      'energy': 'energy_club',
      'vibes': 'vibes_club',
      'luxe': 'luxe_club',
      'godlevel': 'godlevel_club'
    };
    
    return tierMap[tierId] || 'energy_club';
  }
};
